module.exports = __webpack_public_path__ + "media/images/icon__info--white@2x-b20b8b3c3a2ca7d8c1fc116c51879e0a.png";